import { render, staticRenderFns } from "./SatellitalImagesStrip.vue?vue&type=template&id=009356a5&scoped=true"
import script from "./SatellitalImagesStrip.vue?vue&type=script&lang=ts"
export * from "./SatellitalImagesStrip.vue?vue&type=script&lang=ts"
import style0 from "./SatellitalImagesStrip.vue?vue&type=style&index=0&id=009356a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009356a5",
  null
  
)

export default component.exports